import { render, staticRenderFns } from "./Withdrawal.vue?vue&type=template&id=3f2a4b5e&scoped=true"
import script from "./Withdrawal.vue?vue&type=script&lang=js"
export * from "./Withdrawal.vue?vue&type=script&lang=js"
import style0 from "./Withdrawal.vue?vue&type=style&index=0&id=3f2a4b5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2a4b5e",
  null
  
)

export default component.exports